import React from 'react';
import { Spin } from 'antd';

const LazyConvertToPaid = React.lazy(() => import('./ConvertToPaidLoader'));

interface AsyncConvertToPaidProps {
	isTrialExpired?: boolean;
}

export const AsyncConvertToPaid: React.FC<AsyncConvertToPaidProps> = ({
	isTrialExpired,
}) => (
	<React.Suspense fallback={<Spin />}>
		<LazyConvertToPaid isTrialExpired={isTrialExpired} />
	</React.Suspense>
);
